import { 
    VBtn,
    VMenu,
    VList,
    VListItem,
    VListItemTitle,
} from 'vuetify/lib'
import VPage from '@/vuetify_custom/v-pagination';
import ButtonSV from '@/views/fin/salaryadministration/components/ButtonSV.vue'
import DiffModal from '@/views/fin/salaryadministration/components/DiffModal.jsx'
import CompanySummary from '@/views/fin/salaryadministration/components/CompanySummary.jsx'
import PayDetailTable from './Pay_Detail_Table'
import {status_list, customer_type_list as customer_type_list_c} from '@/views/fin/salaryadministration/fields.js'
import BackToolTip from '@/views/fin/salaryadministration/components/BackToolTip.vue'
import PayDetailSearch from './Pay_Detail_Search'
import Select from '@/vuetify_custom/v-form/components/Select.js'
import styles from '../index.module.less'
import styless from './pay.module.less'
import { getCustomerMonthSalaryTotalDetailListApi, exportDetailFileApi } from '../service'


function createdParams() {
    return {
        has_other_subsidy: null,
        total_id: null,
        customer_type:null,
        customer_sub_type:'all',
        team_id:'all',
        modify_flag:'all',
        status_flag: null,
        name:null,
        total_count:0,
        cur_page: 1,
        per_page: 10,
    }
}

export default {
    props: {
        showBackTop: {
            type: Boolean,
            default: () => true
        }
    },
    data() {
        return {
            loading:false,
            c_oading: false,
            params: createdParams(),
            name: '',
            employee_type_list:[],
            check_list: [],
            records: [],
            actions: [
                {
                    label: '薪资明细',
                    value: 'export_detail_list',
                },
                {
                    label: '税局-薪资',
                    value: 'export_salary_for_revenues',
                },
                {
                    label: '税局-离职补偿金',
                    value: 'export_severance_for_revenues',
                }
            ]
        }
    },
    computed: {
        window_height() {
            return this.$store.state.window_height - 155
        },
        currentItem() {
            return this.$route.query || {}
        },
        working_day() {
            let text = ''
            switch (Number(this.currentItem.tab)) {
                case 1:
                    text = '正式员工：应工作天数为25.75天'
                    break;
                case 2:
                    text = '销服团队：应工作天数为25.75天'
                    break;
                case 3:
                    text = '劳务派遣：应工作天数为21.75天'
                    break;
                case 4:
                    text = '外包员工：应工作天数为25.75天'
                    break;
                default:
                    break;
            }
            return text
        }
        // employee_type_list() {
            
        //     return this.currentItem.tab && employee_type[this.currentItem.tab] || []
        // },
    },
    watch: {
        currentItem(val) {
            if (!val.tab) {
                this.params = createdParams()
            }
         
        }
    },
    methods: {
        check() {
            if (!this.check_list.length) {
               this.$vModal.warning({
                title:'提示',
                content:'当前页没有对比数据！'
               })
               return
            }
            this.$refs.diffmodal.edit({
                check_list: this.check_list,
                records: this.records
            })
        },
        getData() {
            this.params.total_id = this.currentItem.id
              // eslint-disable-next-line
              const { total_count, ...params } = this.params
            //   Object.keys(params).forEach(key => {
            //       params[key] = handle_hash[key] ? handle_hash[key](params[key]) : params[key]
            //   })
            this.getTableList({...params, page: params.cur_page})
        },
        getTableList(params) {
            const params_clone = {...params}
            this.loading = true
            this.records = []
            Object.keys(params_clone).forEach(key => {
                if (params_clone[key] === 'all' || key === 'check_list') {
                    delete params_clone[key]
                }
            })
            getCustomerMonthSalaryTotalDetailListApi(params_clone).then(({records, check_list, modify_hash, name, pigeonhole_flag, customer_type_list, customer_type_change_hash, begin_date, end_date, ...other}) => {
                this.name = name
                this.records = records
                this.$refs.manageTable.setParams({
                    modify_hash,
                    records,
                    begin_date,
                    end_date,
                    customer_type_change_hash,
                    customer_type_list,
                    pigeonhole_flag
                })
                this.employee_type_list = customer_type_list
                this.check_list = check_list || []
                Object.keys(other).forEach(key => {
                    this.params[key] = other[key]
                })
            }).catch(() => {
                this.$refs.manageTable.setParams()
            }).finally(() => {
                this.loading = false
            })
        },
    },
    render() {
        const _this = this
        return <div class={styles['pay-contain']}>
         
                <div class={styless['detail-header']}>
                    <span class={styless['title-span']}>
                        {_this.name}
                    </span>
                </div>
                <div>
                    <div style="width:200px;padding:10px">
                        <Select
                            v-model={this.params}
                            field={{
                                type: 'select_field',
                                key: 'customer_type',
                                label:'员工类型',
                                'item-text': 'label',
                                'item-value': 'value',
                                cols: 3,
                                clearable: true,
                                'hide-details': true,
                                items: customer_type_list_c,
                                change: () => {
                                    _this.params.cur_page = 1
                                    this.$nextTick(_this.getData)
                                    _this.$refs.summary.getList()
                                }
                            }}
                        />
                    </div>
                   
                </div>
                <div>
                    <CompanySummary 
                        id={_this.currentItem.id}
                        params={_this.params}
                        ref="summary"
                    />
                </div>
                <div>
                    <PayDetailSearch 
                        employeeTypeList={_this.employee_type_list}
                     
                        v-model={_this.params}
                        on={{
                            search:() => {
                                _this.getData()
                               //  _this.$refs.summary.getList()
                            }
                        }}    
                    />
                </div>
                <div style="position:relative;margin-top:40px">
                    {/* <PayDetailChartContain
                        loading={_this.c_oading}
                        ref="charts"
                    /> */}
                    <VMenu offset-y
                    close-on-click={true}
                        scopedSlots={{
                        activator: ({ on, attrs }) => (
                          <VBtn {...attrs} on={on} color="primary"
                          small 
                                style="margin: 10px 0;"
                          >
                            导出报表
                          </VBtn>
                        ),
                      }}
                    >
                        
                        <VList>
                            {_this.actions.map(action => <VListItem
                            key={action.value}
                            onclick={() => {
                                const params_clone = {..._this.params}
                                        Object.keys(params_clone).forEach(key => {
                                            if (params_clone[key] === 'all') {
                                                delete params_clone[key]
                                            }
                                        })
                                        params_clone.export_type = action.value
                                        console.log('params_clone', params_clone)
                                        exportDetailFileApi(params_clone)
                              }}
                            >
                            <VListItemTitle>{ action.label }</VListItemTitle>
                            </VListItem>)}
                        </VList>
                    </VMenu>
                    
                 
                    <ButtonSV 
                        id={this.currentItem.id} 
                        on={{
                            uploaded: this.getData
                        }}
                    />
                    <VBtn small color="primary"
                        style="margin: 10px 0;"
                        text
                        on={{
                            click:this.check
                        }}
                    >
                        查看对比数据（当前页）
                    </VBtn>
                    <div class={styless['remark-contain']}>
                        {status_list.map(i => <p class={styless['remark-item-contain']}><span class={i.className}></span>{i.title}</p>) }
                    </div>
                </div>
              
                <div class={styles['search-bar-contain']}>
                        <PayDetailTable
                            ref="manageTable"
                            loading={_this.loading}
                            workingDayTip={_this.working_day}
                        
                            on={{
                                adjustSuccess:_this.getData,
                            }}
                        />
                </div>
                <DiffModal ref="diffmodal"/>
                <div class="paginate-fix-bottom">
                    <BackToolTip
                        bottom={this.window_height}
                        className={styless['back-btn']}
                        on={{
                            go: () => {
                                const { path } = this.$route
                                _this.$router.push(path)
                                _this.$emit('back')
                            }
                        }}
                    />
                    {/* <VBtn 
                        style={{
                            bottom: `${this.window_height}px`
                        }}
                        class={styless['back-btn']}
                        small 
                         icon
                         
                        color="primary"
                        on={{
                            click:() => {
                                const { path } = this.$route
                                _this.$router.push(path)
                                _this.$emit('back')
                            }
                        }}
                    >
                  
                        <VIcon>mdi-keyboard-backspace</VIcon>
                </VBtn> */}
                    <VPage
                        current={_this.params.cur_page}
                        total={_this.params.total_count}
                        page-size={_this.params.per_page}
                        size-arr={[10, 20, 50]}
                        on={{
                            changePageSize:(per_page) => {
                                _this.params.per_page = per_page
                                _this.params.cur_page = 1
                                _this.$nextTick(_this.getData) 
                              },
                            pageChange:(new_page) => {
                                _this.params.cur_page = new_page
                                _this.$nextTick(_this.getData) 
                            }
                        }}
                    />
                </div>
               
        </div>
    }
}